import { render } from "./hero.vue?vue&type=template&id=2d62a0dd&scoped=true"
import script from "./hero.vue?vue&type=script&lang=js"
export * from "./hero.vue?vue&type=script&lang=js"

import "./hero.vue?vue&type=style&index=0&id=2d62a0dd&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2d62a0dd"

export default script